<template>
  <div class="manual-panel">
    <v-row dense>
      <v-col cols="12" md="6">
        <v-select
          v-model="command"
          :items="cmdItems"
          item-title="title"
          item-value="value"
          label="充放电命令"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
          rounded="lg"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model.number="powerKw"
          label="充放电功率(kW)"
          type="number"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
          rounded="lg"
          :hint="`范围：[${minKw.toFixed(2)}, ${maxKw.toFixed(2)}]`"
          persistent-hint
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const command = ref('charge')
const cmdItems = [
  { title: '充电', value: 'charge' },
  { title: '放电', value: 'discharge' },
  { title: '待机', value: 'idle' },
]

const powerKw = ref(10)
const minKw = 0
const maxKw = 120

defineExpose({
  getDraft: () => ({
    mode: 'manual',
    command: command.value,
    powerKw: powerKw.value,
    range: [minKw, maxKw],
  }),
})
</script>

<style scoped>
.manual-panel {
  max-width: 560px;
}
</style>
